module.exports = __webpack_public_path__ + "static/media/gray_circle_with_lines.a07d45b7.svg";